import { Component, computed, input } from '@angular/core';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormField } from '@angular/forms/signals';
import { SCHOOL_MESSAGE_BODY_MAX, SchoolMessageComposer } from './school-message-composer';

/** The fields of a message to colleagues — the host supplies the surrounding form and the send button. */
@Component({
  selector: 'app-school-message-form',
  imports: [
    CdkTextareaAutosize,
    MatButtonModule,
    MatFormFieldModule,
    MatIcon,
    MatInputModule,
    MatSelectModule,
    FormField,
  ],
  templateUrl: './school-message-form.html',
  host: { class: 'flex flex-col gap-3' },
})
export class SchoolMessageForm {
  readonly composer = input.required<SchoolMessageComposer>();
  readonly bodyMinRows = input(6);

  readonly bodyMax = SCHOOL_MESSAGE_BODY_MAX;

  readonly undeliveredNames = computed(() =>
    this.composer()
      .undelivered()
      .map((m) => `${m.firstName} ${m.lastName}`)
      .join(', '),
  );
}
